<template>
  <div class="case">
    <div class="center" style="width: 100%;">

      <div  class="center"  style="background-color: palegoldenrod;width: 70%;height: 90em">

        <div   style="background-color: palegoldenrod;width: 70%;height: 90em">

        <div style="font-size: larger;text-align: left;margin-top: 20px;">
          <div>  <el-link :underline="false" style="font-size: medium;margin-left: -200px;">首页</el-link> >  <el-link :underline="false" style="font-size: medium">价格</el-link></div>
        </div>
        <div class="center" style="font-size: 2em;">
          <div style="margin-top: 40px;">选择符合您工作场景的购买计划</div>
        </div>
        <div >
<div class="center" style="margin: 20px;">已有3875人成为PRO版会员</div>


          <div style="margin-top: 50px;  border-radius: 50px;" >

            <el-row>
              <el-button type="primary"  round>个人版</el-button>
              <el-button type="primary"  round>团队版</el-button>
            </el-row>

          </div>


          <!-- 展示个人版-->
<div class="center" style="margin-top: 80px;">
<div class="between" style="width: 60%">

  <div  style="background-color: pink;height: 23em;width: 15em">

    <div style="margin-top: 30px;font-size: 1.2em">每日会员</div>
    <div style="font-size: 2.5em;margin: 30px;">¥ 5.00</div>
    <div class="center">
    <div style="width: 15em;background-color: #2fadf1;text-align: left;white-space: nowrap;">

      <div class="center">
        <div><img  style="height: 20px;width: 20px;display:flex;justify-content: center;margin-top: 2px;" src="../assets/img/price1.png"></div>
        <div>日会员仅限网站使用</div>

      </div>
      <div class="center" style="margin: 10px 0;">
        <div><img  style="height: 20px;width: 20px;display: inline-block;justify-content: center;margin-top: 2px;" src="../assets/img/price1.png"></div>
        <div>无限制图像数量</div>

      </div>
      <div class="center">
        <div><img  style="height: 20px;width: 20px;display:flex;justify-content: center;margin-top: 2px;" src="../assets/img/price1.png"></div>
        <div>无限制文件大小</div>

      </div>
<!--      <div style="margin:15px 0;"><span>11</span></div>-->
<!--      <div><span>11</span></div>-->

    </div>
    </div>



  </div>
  <div style="background-color: pink;height: 23em;width: 15em">



  </div>

</div>
</div>




<!-- 展示团队版-->
          <div v-if="false">

          <div>
          <el-select  v-model="value" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select  style="margin: 50px" v-model="value" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="value" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          </div>

          <div class="center" style="">
<!--            <input type="text" placeholder="留言内容（200字以内）："   >-->

<div class="center"  style="height: 10em;width: 85%;margin-left: 10px;border: #99a9bf 1px solid">

  <div>请选择团队成员数+请选择使用时长+请选择套餐</div>

</div>

          </div>
          <div class="center" style="font-size: 2em;margin-top: 20px;">需要更多帮助？</div>
          <div class="center" style="margin-top: 30px;">

            <el-button style="width: 20%;" type="primary"  round>联系客服</el-button>


          </div>



          </div>
















        </div>




      </div>

      </div>



    </div>

    <Footer/>

  </div>
</template>
<script>
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Banner,
    Footer
  },
  data() {
    return {
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      loading: true,
      caseList: []
    };
  },
  mounted() {
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
  }
};
</script>

<style lang="scss" scoped>


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  //background-color: pink;
}


.one-third-1{
  width: 33.333333%;
  height: 10em;
  //background-color: pink;
}

.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>